import React from 'react';
import { Property } from '../../../types';
import { PropertyCommissionRatesBlock } from './PropertyCommissionRatesBlock';
import { PropertyCommissionTable } from '../../../components/admin/property_edit/PropertyCommissionTable';

interface Props {
  formData: Partial<Property>;
  onChange: (field: keyof Property, value: any) => void;
}

export const PropertyPricingFields: React.FC<Props> = ({ formData, onChange }) => {
  return (
    <div className="space-y-4 text-xs">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div>
          <label className="font-bold text-gray-700 block mb-1">Precio Venta ($ COP) *</label>
          <input
            type="number"
            value={formData.precio_venta ?? ''}
            onChange={(e) => onChange('precio_venta', Number(e.target.value) || 0)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500 font-semibold"
            placeholder="0"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Precio Original ($ COP)</label>
          <input
            type="number"
            value={formData.precio_original ?? ''}
            onChange={(e) => onChange('precio_original', Number(e.target.value) || 0)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500"
            placeholder="0"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Valor Administración ($ COP)</label>
          <input
            type="number"
            value={formData.valor_administracion ?? ''}
            onChange={(e) => onChange('valor_administracion', Number(e.target.value) || 0)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500"
            placeholder="0"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div>
          <label className="font-bold text-gray-700 block mb-1">Renta Estimada Mensual ($ COP)</label>
          <input
            type="number"
            value={formData.renta_estimada ?? ''}
            onChange={(e) => onChange('renta_estimada', Number(e.target.value) || 0)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500"
            placeholder="0"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Descuento (%)</label>
          <input
            type="number"
            step="0.01"
            value={formData.descuento_porcentaje ?? ''}
            onChange={(e) => onChange('descuento_porcentaje', Number(e.target.value) || 0)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500"
            placeholder="Ej: 5.5"
          />
        </div>
        <div>
          <label className="font-bold text-gray-700 block mb-1">Estrategia Comercial</label>
          <input
            type="text"
            value={formData.estrategiaComercial || ''}
            onChange={(e) => onChange('estrategiaComercial', e.target.value)}
            className="w-full p-2 border rounded-lg focus:ring-sky-500"
            placeholder="Ej: Oportunidad, Premium, Remate"
          />
        </div>
      </div>

      {/* Base rates and overrides */}
      <PropertyCommissionRatesBlock formData={formData} onChange={onChange} />

      {/* Commission Breakdown Table based on Sale Price */}
      <PropertyCommissionTable
        value={formData.tabla_comisiones}
        precioBase={formData.precio_venta}
        rateBase={formData.commissionRate}
        onChange={(tiers) => onChange('tabla_comisiones', tiers)}
      />
    </div>
  );
};
